// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"155":"48c382fd","156":"b15a7f48","320":"7a3e24b5","510":"46ac83e4","823":"a50831ea","828":"d6268e73","832":"dfa2e033","900":"b59a10e8","906":"5b64a77c","991":"fc4f46cf"}[chunkId] + ".chunk.js";
};